import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _templateObject;

import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import React from 'react';
import PropTypes from 'prop-types'; // eslint-disable-next-line lodash/import-scope

import isEmpty from 'lodash/isEmpty';
import analytics from '@nerdwallet/analytics';
import { Impression, ImpressionContext } from '@nerdwallet/analytics/react/impression';
import Popover from '@nerdwallet/react-popover';
import Plus from '@nerdwallet/react-icon/gizmo/Plus';
import Delete from '@nerdwallet/react-icon/gizmo/Delete';
import Navigateleft from '@nerdwallet/react-icon/gizmo/Navigateleft';
import Button from '@nerdwallet/react-button';
import { CreditCardSearch } from '@nerdwallet/react-marketplace-search';
import { gql } from '@nerdwallet/apollo';
import Modal from '@nerdwallet/react-modal';
import { createCard } from '@nerdwallet/cc-utils/lib/offer-api/offer-api';
import { getPayloadForCardsByLegacyId } from '@nerdwallet/nw-api-sdk/dist/offer-sdk/credit-cards';
import { ElementInteraction } from '@nerdwallet/nw-client-lib/tracking';
import './compare-add-button.less';
var GENERIC_CARD_IMG = 'https://www.nerdwallet.com/cdn/cc/cc_generic_bw.png';

var CompareAddButton = /*#__PURE__*/function (_React$Component) {
  _inherits(CompareAddButton, _React$Component);

  var _super = _createSuper(CompareAddButton);

  function CompareAddButton(props) {
    var _this;

    _classCallCheck(this, CompareAddButton);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onAddClick", function (impressionId) {
      if (_this.props.analytics.enabled && impressionId) {
        analytics.track('element_interacted', {
          action: 'select',
          entity_name: 'cc_add_to_compare',
          impression_id: impressionId,
          interaction_type: 'press'
        });
      }

      _this.setState({
        selectedCards: [],
        isOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getSelectedCardIDs", function () {
      return _this.state.selectedCards.map(function (card) {
        return card.legacyId;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeModal", function (e) {
      var formClosedEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'form_cancelled';

      if (_this.props.analytics.enabled) {
        analytics.track(formClosedEvent, {
          form_name: 'cc_add_to_compare'
        });
      }

      _this.setState({
        isOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleModalDone", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
        var selectedCards, filteredCards, cardsLegacyIds, cardsToSave;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                selectedCards = _this.state.selectedCards;
                filteredCards = selectedCards.filter(function (card) {
                  return !_this.props.cardsToCompare[card.legacyId];
                });

                if (!filteredCards.length) {
                  _context.next = 8;
                  break;
                }

                cardsLegacyIds = filteredCards.map(function (card) {
                  return card.legacyId;
                });
                _context.next = 6;
                return _this.fetchLegacyCardData(cardsLegacyIds);

              case 6:
                cardsToSave = _context.sent;

                _this.props.saveToCompare({
                  cards: cardsToSave,
                  productLocation: 'compare-add-modal'
                });

              case 8:
                _this.closeModal(e, 'form_submitted');

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "fetchLegacyCardData", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(cardsIds) {
        var offerSDK, payload, _ref3, _ref3$data, response, offers, offersFromPayloadByLegacy;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                offerSDK = _this.props.offerSDK;
                payload = getPayloadForCardsByLegacyId(cardsIds);
                _context2.prev = 2;
                _context2.next = 5;
                return offerSDK.getCreditCards(payload.getJSON());

              case 5:
                response = _context2.sent;
                offers = ((_ref3 = response || {}) === null || _ref3 === void 0 ? void 0 : (_ref3$data = _ref3.data) === null || _ref3$data === void 0 ? void 0 : _ref3$data.offers) || [];
                offersFromPayloadByLegacy = offers.map(function (offer) {
                  return createCard(offer, payload);
                });
                return _context2.abrupt("return", offersFromPayloadByLegacy);

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](2);
                // eslint-disable-next-line no-console
                console.error('Error while fetching legacy card data ', _context2.t0);
                return _context2.abrupt("return", []);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 11]]);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "handleAddCard", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(cardsResults) {
        var selectedCardsIds, newCard;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // CreditCardSearch returns an array of results
                if (!isEmpty(cardsResults)) {
                  selectedCardsIds = _this.getSelectedCardIDs(); // Determine which ids from the search results need to be added

                  newCard = cardsResults.find(function (card) {
                    return !selectedCardsIds.includes(card === null || card === void 0 ? void 0 : card.legacyId);
                  });

                  if (!isEmpty(newCard)) {
                    if (_this.props.analytics.enabled) {
                      analytics.track('cc_add_to_compare_card_updated', {
                        form_name: 'cc_add_to_compare',
                        value_s: newCard === null || newCard === void 0 ? void 0 : newCard.id,
                        was_prefilled: false
                      });
                    } // as of now, CCCB is expecting legacy data (old card format)
                    // const legacyCard = await this.fetchLegacyCardData(newCard);


                    _this.setState(function (prevState) {
                      return {
                        selectedCards: [].concat(_toConsumableArray(prevState.selectedCards), [newCard])
                      };
                    });
                  }
                }

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x3) {
        return _ref4.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "removeCardFromModal", function (card) {
      var cardId = card.legacyId;

      if (_this.props.analytics.enabled) {
        analytics.track('cc_add_to_compare_card_crossed_out', {
          form_name: 'cc_add_to_compare',
          was_prefilled: true,
          value_s: card === null || card === void 0 ? void 0 : card.id
        });
      }

      _this.setState(function (prevState) {
        return {
          selectedCards: prevState.selectedCards.filter(function (selectedCard) {
            return (selectedCard === null || selectedCard === void 0 ? void 0 : selectedCard.legacyId) !== cardId;
          })
        };
      });
    });

    _this.state = {
      selectedCards: [],
      isOpen: false
    };
    return _this;
  }

  _createClass(CompareAddButton, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var popoverContent = /*#__PURE__*/React.createElement("span", null, "Add a card");
      var LEGACY_ID_FIELD = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      fragment SearchFields on CreditCardsOfferV2 {\n        legacyId\n      }\n    "])));
      return /*#__PURE__*/React.createElement(ImpressionContext.Consumer, null, function (value) {
        var _this2$props$analytic, _this2$props$analytic2;

        return /*#__PURE__*/React.createElement("div", {
          className: "add-card-container"
        }, /*#__PURE__*/React.createElement(Popover, {
          type: ['hover'],
          popoverContent: popoverContent,
          placement: "top",
          className: "popover-overlay-trigger",
          popoverClassName: "card-image-popover-add",
          key: "compare-card-image-add",
          id: "compare-card-image-add",
          rootClose: true
        }, /*#__PURE__*/React.createElement(ElementInteraction, {
          type: "CLICK",
          id: "compare-bar-add-card-image",
          elementName: "compare-bar-add-card-image",
          sectionCategory: "compare-bar"
        }, /*#__PURE__*/React.createElement("button", {
          className: "card-image card-image-add",
          onClick: function onClick() {
            return _this2.onAddClick(value === null || value === void 0 ? void 0 : value.impressionId);
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "bar"
        }), /*#__PURE__*/React.createElement(Plus, {
          className: "icon plus"
        })))), /*#__PURE__*/React.createElement(Modal, {
          isOpen: _this2.state.isOpen,
          onRequestClose: _this2.closeModal
        }, /*#__PURE__*/React.createElement(Impression, {
          entityName: "cc_add_to_compare",
          enabled: _this2.props.analytics.enabled,
          eventType: "form_impression",
          payload: {
            section_name: (_this2$props$analytic = _this2.props.analytics) === null || _this2$props$analytic === void 0 ? void 0 : (_this2$props$analytic2 = _this2$props$analytic.payload) === null || _this2$props$analytic2 === void 0 ? void 0 : _this2$props$analytic2.sectionName,
            form_name: 'cc_add_to_compare'
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "compare-add-card-modal-content"
        }, /*#__PURE__*/React.createElement("h3", null, "Which card would you like to compare?"), /*#__PURE__*/React.createElement(CreditCardSearch, {
          onSelectHandler: _this2.handleAddCard,
          searchFragment: LEGACY_ID_FIELD,
          placeholder: "Search card name"
        }), _this2.state.selectedCards.map(function (card, i) {
          var _card$image, _card$image2;

          return /*#__PURE__*/React.createElement("div", {
            className: "pre-select-card__selected-card",
            key: "selected-card-".concat(i)
          }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
            className: "pre-select-card__selected-img",
            src: (card === null || card === void 0 ? void 0 : (_card$image = card.image) === null || _card$image === void 0 ? void 0 : _card$image.source) || GENERIC_CARD_IMG,
            alt: (card === null || card === void 0 ? void 0 : (_card$image2 = card.image) === null || _card$image2 === void 0 ? void 0 : _card$image2.alt) || ''
          })), /*#__PURE__*/React.createElement("div", {
            className: "card-title",
            dangerouslySetInnerHTML: {
              __html: card === null || card === void 0 ? void 0 : card.displayName
            }
          }), /*#__PURE__*/React.createElement("button", {
            type: "button",
            className: "remove-from-compare",
            onClick: function onClick() {
              _this2.removeCardFromModal(card);
            }
          }, /*#__PURE__*/React.createElement(Delete, {
            className: "icon delete"
          })));
        }, this), /*#__PURE__*/React.createElement("div", {
          className: "compare-modal-navigation"
        }, /*#__PURE__*/React.createElement(ElementInteraction, {
          type: "CLICK",
          id: "compare-bar-modal-back",
          elementName: "compare-bar-modal-back",
          sectionCategory: "compare-bar-add-modal"
        }, /*#__PURE__*/React.createElement("button", {
          className: "back-button",
          onClick: _this2.closeModal
        }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Navigateleft, {
          className: "icon navigateleft"
        }), "Back"))), /*#__PURE__*/React.createElement(Button, {
          primary: true,
          className: "done-button",
          onClick: _this2.handleModalDone
        }, "Done"))))));
      });
    }
  }]);

  return CompareAddButton;
}(React.Component);

_defineProperty(CompareAddButton, "propTypes", {
  analytics: PropTypes.shape({
    enabled: PropTypes.bool,
    payload: PropTypes.shape({
      sectionName: PropTypes.string
    })
  }),
  saveToCompare: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  cardsToCompare: PropTypes.objectOf(PropTypes.object),
  offerSDK: PropTypes.shape({
    getCreditCards: PropTypes.func
  }).isRequired
});

_defineProperty(CompareAddButton, "defaultProps", {
  analytics: {
    enabled: false
  },
  cardsToCompare: {}
});

export { CompareAddButton as default };